// interface ChurnZeroEvent {
//   eventName: string;
//   eventDescription?: string;
//   quantity?: number;
//   customFields: ChurnZeroCustomFields;
// }
//
// interface ChurnZeroCustomFields {
//   isCsm: boolean;
//   moniker: string;
// }

function trackEvent({ eventName, eventDescription, quantity, customFields }) {
  const czEvent = [
    'trackEvent',
    eventName,
    eventDescription ?? '',
    quantity ?? 1,
    customFields,
  ];
  window.ChurnZero?.push(czEvent);
}

function makeChurnZeroEvent({
  eventType,
  user,
  retailer,
  path,
  target,
  beacon,
}) {
  if (eventType === 'pageView' && beacon?.id === 'track-analytics') {
    return {
      eventName: 'Track - Access Analytics',
      customFields: {
        isCsm: user.customerSupportLogin,
        moniker: retailer.uri_moniker,
      },
    };
  }

  if (eventType === 'pageView' && beacon?.id === 'notify-email-template') {
    return {
      eventName: 'Notify - Email Template View',
      customFields: {
        isCsm: user.customerSupportLogin,
        moniker: retailer.uri_moniker,
      },
    };
  }

  if (eventType === 'pageView' && beacon?.id === 'notify-analytics-email') {
    return {
      eventName: 'Notify - Access Analytics - Email',
      customFields: {
        isCsm: user.customerSupportLogin,
        moniker: retailer.uri_moniker,
      },
    };
  }

  if (eventType === 'pageView' && beacon?.id === 'notify-analytics-sms') {
    return {
      eventName: 'Notify - Access Analytics - SMS',
      customFields: {
        isCsm: user.customerSupportLogin,
        moniker: retailer.uri_moniker,
      },
    };
  }

  if (eventType === 'pageView' && beacon?.id === 'return-rules-3') {
    return {
      eventName: 'Return - Return Rule Page View',
      customFields: {
        isCsm: user.customerSupportLogin,
        moniker: retailer.uri_moniker,
      },
    };
  }

  if (eventType === 'pageView' && beacon?.id === 'return-analytics') {
    return {
      eventName: 'Return - Access Analytics',
      customFields: {
        isCsm: user.customerSupportLogin,
        moniker: retailer.uri_moniker,
      },
    };
  }

  return null;
}

export default function(event) {
  if (!window.ChurnZero) return;
  if (!event.retailer.salesforce_contracted_account) return;

  const czEvent = makeChurnZeroEvent(event);
  if (czEvent) trackEvent(czEvent);
}
